<template>
  <div class="main lh-15 c-333">
    <div class="content p-r z-3 bgc-fff">
      <div class="nav-anchor z-99 l-0 w-100p bgc-fff test">
        <div class="h-100p m-a d-f jc-sb ai-c fs-16">
          <strong class="d-f ai-c fs-20 fw-500"
            >Trion S1 3D LiDAR Scanner<span class="in-h5 triangle-icon triangle-icon-fff bgs-cover bgp-c"></span
          ></strong>
          <div class="d-f">
            <div class="nav-anchor-item d-f jc-sb ai-c">
              <nuxt-link to="/product/trion-s1-3d-lidar-scanner#overview">Overview</nuxt-link>
              <nuxt-link to="/product/trion-s1-3d-lidar-scanner#feature">Feature</nuxt-link>
              <nuxt-link to="/product/trion-s1-3d-lidar-scanner#download">Download</nuxt-link>
            </div>
            <nuxt-link class="dealer-free-quote-btn d-ib ta-c bgc-222 c-fff in-pc" to="/basicinfo" target="_blank"
              >Free Quote</nuxt-link
            >
          </div>
        </div>
      </div>
      <!-- nav-anchor:end -->
      <section class="area-8 ov-h">
        <div
          class="area-8-in p-r bgp-c bgs-cover lazy-image"
          data-original="@/assets/images/trion-s1-3d-lidar-scanner/SPECs-bg.jpg"
          data-m-original="@/assets/images/trion-s1-3d-lidar-scanner/SPECs-bg-m.jpg"
        >
          <div class="d-f jc-sb area-8-content ov-h">
            <div
              class="area-8-img-box bgs-cover in-pc lazy-image"
              data-original="@/assets/images/trion-s1-3d-lidar-scanner/SPECs-pic.png"
            ></div>
            <div class="specs c-fff reveal">
              <h2 class="ff-asb" id="SPECS">SPECs</h2>
              <table>
                <tr>
                  <td>
                    <strong>Range</strong>
                    <span>120m</span>
                  </td>
                  <td>
                    <strong>Sensors</strong>
                    <span>16</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Laser Class</strong>
                    <span>Class 1/λ 905nm</span>
                  </td>
                  <td>
                    <strong>Vertical Angular Resolution</strong>
                    <span>2°</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>FOV</strong>
                    <span>360°×270°</span>
                  </td>
                  <td>
                    <strong>Horizontal Angular Resolution</strong>
                    <span>0.36°</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Ingress Protection</strong>
                    <span>IP54</span>
                  </td>
                  <td>
                    <strong>Accuracy</strong>
                    <span>0.8-2cm</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Processing</strong>
                    <span>Real-Time</span>
                  </td>
                  <td>
                    <strong>Carrier</strong>
                    <span>Handheld, Backpack or shoulder strap</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Datalogger weight</strong>
                    <span>2.2Kg</span>
                  </td>
                  <td>
                    <strong>Battery life (Dual batteries)</strong>
                    <span>4h</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Scanner Weight</strong>
                    <span>1.8Kg</span>
                  </td>
                  <td>
                    <strong>Storage Capacity</strong>
                    <span>512GB</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Point Cloud</strong>
                    <span>320,000</span>
                  </td>
                  <td></td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  // import bannerScroll from '@/mixins/bannerScroll'
  export default {
    // mixins: [bannerScroll],
    data() {
      return {}
    },
    head() {
      return {
        script: [
          {
            type: 'application/ld+json',
            json: {
              '@context': 'https://schema.org/',
              '@type': 'ItemPage',
              '@graph': [
                {
                  '@type': 'Product',
                  name: 'Trion S1 LiDAR 3D Scanner',
                  url: 'https://www.fjdynamics.com/product/trion-s1-3d-lidar-scanner',
                  image: 'https://www.fjdynamics.com/images/trion-s1-3d-lidar-scanner/Overview-pic.jpg',
                  description:
                    'FJD Trion S1 LiDAR 3D scanner SLAM-based, high portability: handheld, backpack, drone, car, ship.',
                  brand: {
                    '@type': 'Brand',
                    name: 'FJDynamics'
                  },
                  review: [
                    {
                      '@type': 'Review',
                      reviewBody: 'Easy use with high accuracy.',
                      reviewRating: {
                        '@type': 'Rating',
                        ratingValue: '5',
                        bestRating: '5'
                      },
                      author: {
                        '@type': 'Person',
                        name: 'Huguette'
                      }
                    }
                  ]
                },
                {
                  '@type': 'BreadcrumbList',
                  itemListElement: [
                    {
                      '@type': 'ListItem',
                      position: 1,
                      name: 'Home',
                      item: 'https://www.fjdynamics.com'
                    },
                    {
                      '@type': 'ListItem',
                      position: 2,
                      name: 'Product',
                      item: 'https://www.fjdynamics.com/product'
                    },
                    {
                      '@type': 'ListItem',
                      position: 3,
                      name: 'Trion S1 LiDAR 3D Scanner'
                    }
                  ]
                }
              ]
            }
          }
        ],
        title: 'Trion S1 Handheld LiDAR 3D Scanner, 0.8-2cm High Accuracy',
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'Handheld LiDAR scanner, 3D LiDAR scanner, LiDAR 3D scanner'
          },
          // hid is used as unique identifier. Do not use `vmid` for it as it will not work
          {
            hid: 'description',
            name: 'description',
            content:
              'FJD Trion S1 LiDAR 3D scanner, high portability: handheld, backpack, drone, car, ship. 320,000 scan points per second, quickly catch high-quality scans.'
          }
        ]
      }
    },
    created() {},
    mounted() {
      // this.createAnim()
    },
    methods: {}
  }
</script>

<style scoped lang="scss">
  @media screen and (min-width: 768px) {
    .fs-40 {
      font-size: 0.4rem;
    }
    .fs-20 {
      font-size: 0.2rem;
    }
    .fs-18 {
      font-size: 0.18rem;
    }
    .fs-16 {
      font-size: 0.16rem;
    }

    .pl-360 {
      padding-left: 3.6rem;
    }
    .pr-360 {
      padding-right: 3.6rem;
    }
    .content h2 {
      font-size: 0.48rem;
    }
    .main {
      margin-top: 3.958vw;
    }

    /* nav-anchor */
    .nav-anchor {
      height: 0.56rem;
      top: 0.75rem;
      position: sticky;
      box-shadow: 0px 0.02rem 0.04rem 0px rgba(0, 0, 0, 0.1);
    }
    .nav-anchor > div {
      padding-left: 1.6rem;
      padding-right: 1.6rem;
    }
    .nav-anchor a {
      margin-left: 0.8rem;
    }
    .nav-anchor .nav-anchor-item a:hover {
      font-weight: 700;
    }
    .nav-anchor .dealer-free-quote-btn {
      width: 1.2rem;
      line-height: 0.32rem;
      transition: background-color 0.3s linear;
    }
    .nav-anchor .dealer-free-quote-btn:hover {
      color: #fff;
      background-color: rgba(34, 34, 34, 0.85);
    }

    /* area-8 */
    .area-8-in {
      height: 13.3rem;
      background-image: url('@/assets/images/trion-s1-3d-lidar-scanner/SPECs-bg.jpg');
    }
    .area-8-content {
      padding: 0 2.11rem 0 0.96rem;
    }
    .area-8-img-box {
      margin-top: 3.28rem;
      width: 7.6rem;
      height: 7.6rem;
      background-image: url('@/assets/images/trion-s1-3d-lidar-scanner/SPECs-pic.png');
    }
    .area-8 .specs {
      margin-top: 1.28rem;
    }
    .area-8 .specs h2 {
      margin-bottom: 0.6rem;
    }
    .area-8 table td {
      width: 3.5rem;
      position: relative;
      padding: 0.2rem 0 0.28rem;
    }
    .area-8 table td strong,
    .area-8 table td span {
      display: block;
    }
    .area-8 table td strong {
      font-size: 0.24rem;
      font-weight: 400;
      margin-bottom: 0.1rem;
    }
    .area-8 table td::before {
      content: '';
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
      height: 1px;
      width: 0.7rem;
      background-color: #fff;
    }
  }
</style>
